export default {
      id: "full-screen-exit-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#full-screen-exit",
      toString: function () {
        return this.url;
      }
    }